import { render, staticRenderFns } from "./LanguageKeyForm.vue?vue&type=template&id=6fdb8e42&scoped=true"
import script from "./LanguageKeyForm.vue?vue&type=script&lang=js"
export * from "./LanguageKeyForm.vue?vue&type=script&lang=js"
import style0 from "./LanguageKeyForm.vue?vue&type=style&index=0&id=6fdb8e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb8e42",
  null
  
)

export default component.exports